import { services } from "../data";
import Link from "../components/Link";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SectionHeader from "../components/SectionHeader";
import ServiceCard from "../components/ServiceCard";

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Our Services"
        title="Six beauty paths, one luxury standard."
        desc="Makeup, hair, skin, spa, nails, and academy programs designed with care."
        image="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad dark-section">
        <div className="container">
          <Reveal>
            <SectionHeader
              eyebrow="Service Menu"
              title="Explore every beauty path at Orchid."
              desc="Every service is structured around comfort, precision, and a polished finish."
            />
          </Reveal>

          <nav className="topic-strip" aria-label="Service topics">
            {services.map((service) => (
              <a href={`#${service.id}`} key={service.id}>{service.name}</a>
            ))}
          </nav>

          <div className="service-grid">
            {services.map((service, index) => (
              <Reveal delay={index * 70} key={service.id}>
                <ServiceCard service={service} index={index} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container cta-split">
          <div>
            <p className="section-eyebrow">Need Multiple Services?</p>
            <h2 className="section-title">Plan the whole visit in one appointment.</h2>
          </div>
          <Link to="/contact" className="btn-primary bits-magnetic"><span>Send Appointment Request</span></Link>
        </div>
      </section>
    </>
  );
}
